import { Fragment, useContext, useEffect, useState } from 'react';

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { RadioButton } from 'primereact/radiobutton';

import { LayoutContext } from 'src/layout/context/layoutcontext';

import { AuthService } from 'src/service/AuthService';

import { AppStorage } from 'src/service/UserStorage';
import { ToastService } from '@iamsoftware/react-hooks';

export default function Login() {

  const { layoutConfig } = useContext(LayoutContext);

  const [formType, setFormType] = useState<string>('Login');

  const containerClassName = classNames('surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden', { 'p-input-filled': layoutConfig.inputStyle === 'filled' });

  return (
    <div className={containerClassName}>

      <div className="flex flex-column align-items-center justify-content-center">
        <img src="/iam/iam-econtract.png" alt="IAM-ECONTRACT" className="mb-5 flex-shrink-0" style={{ width: '20rem' }} />

        <div style={{ borderRadius: '56px', padding: '0.3rem', background: 'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)' }}>
          <div className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: '53px' }}>
            <div className="text-center mb-5">
              <div className="text-900 text-3xl font-medium mb-3">{formType === 'Login' ? 'Đăng nhập' : 'Quên mật khẩu'}</div>
              <span className="text-600 font-medium">Quản lý hợp đồng</span>
            </div>

            {formType === 'Login' && <LoginForm setFormType={setFormType} />}
            {formType === 'ResetPassword' && <ResetPasswordForm setFormType={setFormType} />}
          </div>
        </div>
      </div>
    </div>
  );
}

const LoginForm = ({ setFormType }) => {

  const [submitting, setSubmitting] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [partyTaxId, setPartyTaxId] = useState('');
  const [statusLogin, setStatusLogin] = useState('Agent');

  useEffect(() => {
    getToken();
    if (AppStorage.get('partyTaxId')) {
      setPartyTaxId(AppStorage.get('partyTaxId'))
    }
  }, []);
  const getToken = () => {
    AuthService.getToken().then(({ moquiSessionToken }) => {
      AppStorage.set('moquiSessionToken', moquiSessionToken);
    });
  }

  const handleSubmit = event => {
    let _userName = username;
    if (statusLogin === 'Agent') {
      _userName = `${username}_${partyTaxId}`
    }
    if (!submitting) {
      setSubmitting(true);
      AuthService.login(`${_userName}`, password).then(data => {
        if (data.isSuccess === 'Y') {
          AppStorage.set('moquiSessionToken', data.moquiSessionToken);
          AppStorage.set('partyTaxId', partyTaxId);
          window.location.hash = '/';
        } else {
          data?.errors.forEach(error => {
            ToastService.error(error);
          });
          getToken();
        }
      }).catch(() => getToken()).finally(() => {
        setSubmitting(false);
      });
    }
    event.preventDefault();
  }
  return (
    <Fragment>
      <form onSubmit={handleSubmit} className="flex flex-column md:w-30rem mx-auto">
        {(['Administrator', 'Agent']).includes(statusLogin) && <label htmlFor="partyTaxId" className="block text-900 text-xl font-medium mb-2">Mã số thuế</label>}
        {(['Administrator', 'Agent']).includes(statusLogin) && <InputText id="partyTaxId" className="w-full mb-5" value={partyTaxId} onChange={e => setPartyTaxId(e.target.value)} required />}

        <label htmlFor="username" className="block text-900 text-xl font-medium mb-2">Tài khoản</label>
        <InputText id="username" className="w-full mb-5" value={username} onChange={e => setUsername(e.target.value)} required />

        <label htmlFor="password" className="block text-900 text-xl font-medium mb-2">Mật khẩu</label>
        <Password id="password" value={password} onChange={e => setPassword(e.target.value)} toggleMask feedback={false} className="w-full mb-5" inputClassName="w-full" required />

        <Button label="Đăng nhập" icon="pi pi-user" className="w-full" loading={submitting} />
      </form>
      <div className="grid mt-2">
        <div className="col-12 text-right">
          <span className="text-primary pointer" onClick={() => setFormType('ResetPassword')}>Quên mật khẩu?</span>
        </div>
      </div>
    </Fragment>
  );
}

const ResetPasswordForm = ({ setFormType }) => {
  const [submitting, setSubmitting] = useState(false);
  const [username, setUsername] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [partyTaxId, setPartyTaxId] = useState('');

  useEffect(() => {
    if (AppStorage.get('partyTaxId')) {
      setPartyTaxId(AppStorage.get('partyTaxId'))
    }
  }, []);

  const handleSubmit = event => {
    const _userName = `${username}_${partyTaxId}`;

    if (!submitting) {
      setSubmitting(true);
      AuthService.resetPassword(_userName, emailAddress).then((data) => {
        ToastService.success('Đặt lại mật khẩu thành công. Quý khách vui lòng kiểm tra Hộp thư đến email.');
        setFormType('Login');

      }).catch((err) => {
        const errorMsg = err?.response?.data?.errors || err?.response?.data?.error || err?.message || 'Có lỗi xảy ra khi lấy lại mật khẩu';
        ToastService.error(errorMsg);
      }).finally(() => {
        setSubmitting(false);
      });
    }
    event.preventDefault();
  }
  return (
    <Fragment>
      <form onSubmit={handleSubmit} className="flex flex-column md:w-30rem mx-auto">
        <label htmlFor="partyTaxId" className="block text-900 text-xl font-medium mb-2">Mã số thuế</label>
        <InputText id="partyTaxId" className="w-full mb-5" value={partyTaxId} onChange={e => setPartyTaxId(e.target.value)} required />

        <label htmlFor="username" className="block text-900 text-xl font-medium mb-2">Tài khoản</label>
        <InputText id="username" className="w-full mb-5" value={username} onChange={e => setUsername(e.target.value)} required />

        <label htmlFor="emailAddress" className="block text-900 text-xl font-medium mb-2">Email</label>
        <InputText id="emailAddress" className="w-full mb-5" value={emailAddress} onChange={e => setEmailAddress(e.target.value)} required />

        <Button label="Lấy lại mật khẩu" icon="pi pi-history" className="w-full" severity="warning" loading={submitting} />
      </form>
      <div className="grid mt-2">
        <div className="col-12">
          <span className="text-primary pointer" onClick={() => setFormType('Login')}><i className="pi pi-arrow-left mr-2"></i>Quay lại</span>
        </div>
      </div>
    </Fragment>
  );
}
